import type { Operator } from "./index.js"

export const before: Operator = {
  key: "before",
  label: "is before",
  icon: "arrow-left",
  value: "scalar",
  fn: (a, b) => new Date(a as string) < new Date(b as string),
}

export const after: Operator = {
  key: "after",
  label: "is after",
  icon: "arrow-right",
  value: "scalar",
  fn: (a, b) => new Date(a as string) > new Date(b as string),
}

export const onOrBefore: Operator = {
  key: "onOrBefore",
  label: "is on or before",
  icon: "arrow-left",
  value: "scalar",
  fn: (a, b) => new Date(a as string) <= new Date(b as string),
}

export const onOrAfter: Operator = {
  key: "onOrAfter",
  label: "is on or after",
  icon: "arrow-right",
  value: "scalar",
  fn: (a, b) => new Date(a as string) >= new Date(b as string),
}
